<div class="generic-modal-root">  
    <div class="row-padding">
      <div class="row">
        <form
          *ngIf="form"
          [formGroup]="form"
          class="m-form m-form--fit m-form--label-align-right"
        >
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Name </label>
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control m-input"
                formControlName="name"
              />
            </div>
            <span style="color:red" *ngIf="form.invalid && form.dirty" class="m-form__help" >
                A name for the report is required.
              </span>
          </div>
  
          <div style="display: flex; justify-content: space-between;">
            <button
              (click)="saveAndClose()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Save
            </button>
            <button
              (click)="close()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>